import { Search } from "lucide-react";

import { useCurrentUser } from "~/lib/auth";

import { Kbd } from "../Kbd";
import { ThemeToggle } from "../ThemeToggle";
import { UserMenu } from "../UserMenu";

export function TopBar(): React.ReactElement {
    const { data: user } = useCurrentUser();
    return (
        <header className="app-shell__topbar" aria-label="Top bar">
            <button
                type="button"
                className="cluster-xs press-crush"
                style={{
                    padding: "6px 12px",
                    border: "var(--border-hairline) solid var(--color-border)",
                    borderRadius: "var(--radius-md)",
                    background: "var(--color-surface)",
                    color: "var(--color-text-muted)",
                    fontSize: "var(--font-size-13)",
                    cursor: "pointer",
                }}
                onClick={() => {
                    const evt = new KeyboardEvent("keydown", {
                        key: "k",
                        metaKey: true,
                        bubbles: true,
                    });
                    window.dispatchEvent(evt);
                }}
            >
                <Search size={14} />
                <span>Search</span>
                <Kbd>⌘K</Kbd>
            </button>

            <div className="cluster-xs">
                <ThemeToggle />
                {user && <UserMenu user={user} />}
            </div>
        </header>
    );
}
